import React, { useEffect, useState } from "react";
import { Alert, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, MenuList, Modal, Paper, Snackbar, Typography, Dialog, DialogTitle, DialogContent, DialogActions, Button, Switch } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import * as LayoutThunks from "./layout.thunks";
import { RootState } from "../../globals/redux/store/store.index";
import "./layout.index.less";
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import Header from "../../globals/components/header/header.index";
import { Close, ExitToApp, Menu as AppMenu, ModelTraining, QuestionAnswerOutlined, Restore, Videocam, WarningAmberOutlined, Logout } from "@mui/icons-material";
import LogoutIcon from '@mui/icons-material/Logout';
import TranslateIcon from '@mui/icons-material/Translate';
import * as GlobalThunks from "./layout.thunks";
import * as ChatThunks from "../chatV2/chat.thunks";
import dayjs from "dayjs";
import HistoryIcon from '@mui/icons-material/History';
import LoginIcon from '@mui/icons-material/Login';
import * as ChatActions from "../chatV2/chat.actions";
import * as LayoutActions from "./layout.actions";
const Layout: React.FC = () => {

    // Selectors
    const globalAppState = useSelector(
        (state: RootState) => state.globalStateReducer,
    );

    const chatState = useSelector(
        (state: RootState) => state.chatV2Reducer,
    );

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const [isMobileView, setIsMobileView] = useState<boolean>(false);
    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(window.innerWidth <= 480); // Adjust the breakpoint as needed
        };

        // Initial check on component mount
        handleResize();

        // Event listener for window resize
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    const shouldRenderIconButton = localStorage.getItem('freeUsageAllowed') && localStorage.getItem('freeUsageAllowed') == '1' ? false : true
    const [showRedirectionWarning, setShowRedirectionWarning] = useState<boolean>(false);
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [languageMenuAnchorEl, setLanguageMenuAnchorEl] = useState(null);
    const [selectedLanguage, setSelectedLanguage] = useState('English');
    const [isVideoModeOn, setIsVideoModeOn] = useState(false);
    const menuOpen = Boolean(anchorEl);
    const canAccessQnA = localStorage.getItem("canAccessQnA");
    const isBetaTester = localStorage.getItem("isBetaTester");
    const [isParticipated, setIsParticipated] = useState(localStorage.getItem("isParticipated"));
    const [showTooltip, setShowTooltip] = useState(false);
    // const canAccessVideo = localStorage.getItem("canAccessVideo");
    const handleHistoryButtonClick = () => {
        console.log("button clicked");
        dispatch(ChatActions.setToggleHistory(true))
        console.log(chatState.setToggleHistory)
        navigate("/chathistory")
    };

    const openDialog = () => {
        setIsDialogOpen(true);
    };

    const closeDialog = () => {
        setIsDialogOpen(false);
    };

    const confirmLogout = () => {
        handleLogout();
        closeDialog();
    };

    useEffect(() => {
        const refreshTokenExpiresOn = localStorage.getItem("refreshTokenExpiresOn");
        if (refreshTokenExpiresOn) {
            try {

                const dt = dayjs(refreshTokenExpiresOn);
                const now = dayjs(new Date());

                if (now > dt) {
                    // Refresh token is expired.
                    setShowRedirectionWarning(true);
                    setTimeout(() => {
                        handleLogout();
                    }, 2000);
                }

            } catch (error) {
                console.log("Nothing to see here!!")
            }
        }

        // eslint-disable-next-line
    }, []);

    if (canAccessQnA !== "yes" && window.location.pathname === "/q-and-a") {
        return <Navigate to="/chat" />
    }

    // if (window.location.pathname.startsWith("/v2") && (!isBetaTester || isBetaTester.toLowerCase() !== "yes")) {
    //     return <Navigate to="/chat" />
    // }
    if (window.location.pathname.startsWith("/old") && (!isBetaTester || isBetaTester.toLowerCase() !== "yes")) {
        return <Navigate to="/chat" />
    }

    const handleNotificationClose = (
        event: React.SyntheticEvent | Event,
        reason?: string,
    ) => {
        if (reason === "clickaway") {
            return;
        }
        dispatch(LayoutThunks.closeNotificationMessage());
    };

    const handleLogout = () => {
        const freeVal = localStorage.getItem('freeUsageAllowed')
        const machine_id = localStorage.getItem('machine_id')
        localStorage.clear();
        sessionStorage.clear();
        localStorage.setItem('freeUsageAllowed', freeVal)
        localStorage.setItem('machine_id', machine_id)
        dispatch(GlobalThunks.resetState());
        window.location.href = "/login";
    }
    const handleLogin = () => {
        // localStorage.setItem('loggedIn', 'true');
        // setIsLoggedIn(true); // Update the login state
        navigate("/login");
    };


    const handleMenuButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    // Function to call API when radio button is clicked
    // const handleParticipationResponse = async (response) => {
    //     handleMenuClose();
    //     const wasParticipated = isParticipated === "true";
    //     const email = localStorage.getItem("authenticatedUser") || "";
    //     const encodedEmail = window.btoa(email);
    //     const encodedResponse = window.btoa(response);
    //     const baseUrl = process.env.REACT_APP_API_BASE_URL || "";
    //     const url = `${baseUrl}engagement/participation?e=${encodedEmail}&r=${encodedResponse}`;
    //     if (response === 'yes') {
    //         setIsParticipated('true');
    //     } else {
    //         setIsParticipated('false');
    //     }
    //     try {
    //         await fetch(url, {
    //             method: "GET",
    //             headers: {
    //                 "Content-Type": "application/json"
    //             }
    //         });
    //     } catch (err) {
    //         // Optionally handle error
    //     }
    //     if (response === 'yes') {
    //         console.log(response);
    //         localStorage.setItem("isParticipated", 'true');
    //         setIsParticipated('true');
    //         const message = wasParticipated
    //             ? "Already a participant, thanks!"
    //             : "Thankyou for participating in our 6 daily question program.";
    //         dispatch(LayoutThunks.setNotificationMessage(true, message, "success"));
    //     } else {
    //         console.log(response);
    //         localStorage.setItem("isParticipated", 'false');
    //         setIsParticipated('false');
    //         dispatch(LayoutThunks.setNotificationMessage(true, "You response is saved, Thanks!", "success"));
    //     }
    // };

    const handleParticipationResponse = async (response) => {
        handleMenuClose();

        const email = localStorage.getItem("authenticatedUser");
        if (!email) return;

        const isYes = response === "yes";
        const participatedValue = isYes ? "true" : "false";
        setIsParticipated(participatedValue);
        const encodedEmail = window.btoa(email);
        const encodedResponse = window.btoa(response);

        const baseUrl = process.env.REACT_APP_API_BASE_URL || "";
        const url = `${baseUrl}engagement/participation?e=${encodedEmail}&r=${encodedResponse}`;

        try {
            const res = await fetch(url, { method: "GET" });
            const data = await res.json();

            const currentRatingCount = data.current_rating_count;
            const wasParticipated = currentRatingCount > 0;

            const participatedValue = isYes ? "true" : "false";
            setIsParticipated(participatedValue);
            localStorage.setItem("isParticipated", participatedValue);

            let message;
            if (isYes) {
                message = wasParticipated
                    ? "You have already participated. Thanks!"
                    : "Thank you for participating in our 6 daily question program.";
            } else {
                message = "Your response has been saved. Thanks!";
            }
            dispatch(
                LayoutThunks.setNotificationMessage(true, message, "success")
            );
        } catch (err) {
            console.error("Participation API failed", err);
            dispatch(
                LayoutThunks.setNotificationMessage(
                    true,
                    "Something went wrong. Please try again.",
                    "error"
                )
            );
        }
    };


    const renderHeaderRightComponentOptions = () => {
        let options: any[] = [];

        if (location.pathname === "/chat") {

            // if (canAccessQnA.toLowerCase() === "yes") {
            if (canAccessQnA === "yes") {
                options.push(
                    <MenuItem className="menu-item" key="q-and-a" onClick={() => {
                        handleMenuClose();
                        dispatch(GlobalThunks.resetState());
                        // navigate("/v2/q-and-a");
                        navigate("/q-and-a");
                    }}>
                        <ListItemIcon><ModelTraining /></ListItemIcon>
                        <ListItemText className="menu-item-text">Go To Q&A Training</ListItemText>
                    </MenuItem>
                )
            }
            // if (canAccessVideo.toLowerCase() === "yes") {
            // if (chatState.chatType === "video") {
            //     options.push(
            //         <MenuItem className="menu-item" key="video-chat" onClick={() => {
            //             handleMenuClose();
            //             setTimeout(() => {
            //                 dispatch(ChatThunks.setChatType("text"));
            //             }, 300);
            //         }}>
            //             <ListItemIcon><Close /></ListItemIcon>
            //             <ListItemText className="menu-item-text">Exit Video Mode</ListItemText>
            //         </MenuItem>
            //     )
            // }
            // else if (chatState.chatType === "text") {
            //     options.push(
            //         <MenuItem className="menu-item" key="video-chat" onClick={() => {
            //             handleMenuClose();
            //             setTimeout(() => {
            //                 dispatch(ChatThunks.setChatType("video"));
            //             }, 300);
            //         }}>
            //             <ListItemIcon><Videocam /></ListItemIcon>
            //             <ListItemText className="menu-item-text">Switch To Video Mode</ListItemText>
            //         </MenuItem>
            //     )
            // }

            if (chatState.messages.length > 0) {
                options.push(
                    <MenuItem className="menu-item" key="restart-converation" onClick={() => {
                        handleMenuClose();
                        setTimeout(() => {
                            dispatch(ChatThunks.restartConversation(true));
                        }, 300);
                    }}>
                        <ListItemIcon><Restore /></ListItemIcon>
                        <ListItemText className="menu-item-text">Restart Conversation</ListItemText>
                    </MenuItem>
                )
            }
            else {
                options.push(
                    <MenuItem
                        className="menu-item"
                        key="restart-converation"
                        disabled
                    >
                        <ListItemIcon><Restore /></ListItemIcon>
                        <ListItemText className="menu-item-text">Restart Conversation</ListItemText>
                    </MenuItem>
                );
            }
        }
        // else if (location.pathname === "/v2/q-and-a") {
        else if (location.pathname === "/q-and-a") {
            options.push(
                <MenuItem className="menu-item" key="root" onClick={() => {
                    handleMenuClose();
                    setTimeout(() => {
                        dispatch(GlobalThunks.resetState());
                        // navigate("/v2");
                        navigate("/chat");
                    }, 300);
                }}>
                    <ListItemIcon><QuestionAnswerOutlined /></ListItemIcon>
                    <ListItemText className="menu-item-text">Converse</ListItemText>
                </MenuItem>
            )
        }
        // {
        //     shouldRenderIconButton && isMobileView && (
        //         options.push(
        //             <MenuItem className="menu-item" key="history-chat" onClick={handleHistoryButtonClick}>
        //                 <ListItemIcon title="history" aria-label="history"><HistoryIcon /></ListItemIcon>
        //                 <ListItemText className="menu-item-text">Chat History</ListItemText>
        //             </MenuItem>
        //         )
        //     )
        // }

        options.push(
            <MenuItem className="menu-item" key="logout-chat" onClick={() => {
                openDialog();
            }}>
                <ListItemIcon onClick={confirmLogout} title="Logout" aria-label="Logout"><LogoutIcon /></ListItemIcon>
                <ListItemText className="menu-item-text">Logout</ListItemText>
            </MenuItem>
        )

        return (<MenuList>{options}</MenuList>);

    }

    const renderHeaderRightMenu = () => {
        // if (location.pathname === "/v2" || location.pathname === "/v2/q-and-a") 
        if (location.pathname === "/chat" || location.pathname === "/q-and-a" || location.pathname.includes("/book")) {
            return (<>
                <div className="menu"><IconButton className="icon-button" id="page-menu" title="Menu" aria-label="Menu" onClick={handleMenuButtonClick} >
                    <AppMenu />
                </IconButton></div>
                <Menu
                    className="header-menu"
                    anchorEl={anchorEl}
                    open={menuOpen}
                    onClose={handleMenuClose}
                    elevation={0}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                >
                    {renderHeaderRightComponentOptions()}
                </Menu>
            </>)
        }
        else {

            // if (canAccessQnA === "yes") {
            //     if (location.pathname === "/chat") {
            //         return (
            //             <IconButton onClick={() => {
            //                 dispatch(GlobalThunks.resetState());
            //                 navigate("/q-and-a");
            //             }} title="Q And A" aria-label="Q And A">
            //                 <ModelTraining />
            //             </IconButton>
            //         );
            //     }
            //     else if (location.pathname === "/q-and-a") {
            //         return (
            //             <IconButton onClick={() => {
            //                 dispatch(GlobalThunks.resetState());
            //                 navigate("/chat");
            //             }} title="Converse" aria-label="Converse">
            //                 <QuestionAnswerOutlined />
            //             </IconButton>
            //         );
            //     }
            // }

            if (canAccessQnA === "yes") {
                if (location.pathname === "/old") {
                    return (
                        <IconButton onClick={() => {
                            dispatch(GlobalThunks.resetState());
                            navigate("/old/q-and-a");
                        }} title="Q And A" aria-label="Q And A">
                            <ModelTraining />
                        </IconButton>
                    );
                }
                else if (location.pathname === "/old/q-and-a") {
                    return (
                        <IconButton onClick={() => {
                            dispatch(GlobalThunks.resetState());
                            navigate("/old");
                        }} title="Converse" aria-label="Converse">
                            <QuestionAnswerOutlined />
                        </IconButton>
                    );
                }
            }

            return (<></>);
        }
    }

    let languages = [
        { value: 'English', label: 'English (English)' },
        { value: 'العربية (الإمارات)', label: 'العربية (الإمارات) (Arabic - UAE)' },
        { value: '中文', label: '中文 (Chinese)' },
        { value: 'Dansk', label: 'Dansk (Danish)' },
        { value: 'Deutsch', label: 'Deutsch (German)' },
        { value: 'Ελληνικά', label: 'Ελληνικά (Greek)' },
        { value: 'Español', label: 'Español (Spanish)' },
        { value: 'Français', label: 'Français (French)' },
        { value: 'Hinglish', label: 'Hinglish (Hindi-English)' },
        { value: 'हिन्दी', label: 'हिन्दी (Hindi)' },
        { value: '한국어', label: '한국어 (Korean)' },
        // { value: 'Polski', label: 'Polski (Polish)' },
        { value: 'Português', label: 'Português (Portuguese)' },
        { value: 'Русский', label: 'Русский (Russian)' },
        { value: 'Türkçe', label: 'Türkçe (Turkish)' }
    ];

    if (canAccessQnA == 'yes') {
        const additionalLanguages = [
            { value: 'Español', label: 'Español (Spanish)' },
            { value: 'Français', label: 'Français (French)' },
            { value: '日本語', label: '日本語 (Japanese)' },
            { value: 'Italiano', label: 'Italiano (Italian)' },
            { value: 'தமிழ்', label: 'தமிழ் (Tamil)' },
            { value: 'Bahasa Indonesia', label: 'Bahasa Indonesia (Indonesian)' },
            { value: 'Nederlands', label: 'Nederlands (Dutch)' },
            { value: 'Filipino', label: 'Filipino (Filipino/Tagalog)' },
            { value: 'Svenska', label: 'Svenska (Swedish)' },
            { value: 'Български', label: 'Български (Bulgarian)' },
            { value: 'Română', label: 'Română (Romanian)' },
            { value: 'Čeština', label: 'Čeština (Czech)' },
            { value: 'Suomi', label: 'Suomi (Finnish)' },
            { value: 'Hrvatski', label: 'Hrvatski (Croatian)' },
            { value: 'Malay', label: 'Malay (Malay)' },
            { value: 'Slovenčina', label: 'Slovenčina (Slovak)' },
            { value: 'Українська', label: 'Українська (Ukrainian)' },
            { value: 'Magyar', label: 'Magyar (Hungarian)' },
            { value: 'Norsk', label: 'Norsk (Norwegian)' },
            { value: 'Tiếng Việt', label: 'Tiếng Việt (Vietnamese)' }
        ];

        languages = [
            ...new Map(
                [...languages, ...additionalLanguages].map(lang => [lang.value, lang])
            ).values()
        ];
    }


    const menuItemStyle = {
        selected: {
            backgroundColor: 'rgb(35, 107, 72)',
            color: 'white',
        },
        hover: {
            backgroundColor: '#f0f0f0',
        },
    };

    const handleLanguageMenuClick = (event) => {
        setLanguageMenuAnchorEl(event.currentTarget);
    };

    const handleLanguageMenuChange = () => {
        setLanguageMenuAnchorEl(null);
    };

    const handleLanguageChange = (language) => {
        dispatch(LayoutActions.setLanguage(language));
        setSelectedLanguage(language);
        handleLanguageMenuChange();
    };


    const chatModeHandler = () => {
        setIsVideoModeOn(!isVideoModeOn)
        if (isVideoModeOn == false) {
            sessionStorage.setItem("prevPath", '');
            setTimeout(() => {
                navigate('/video-chat')
            }, 500);
        }
    };



    const handleMouseEnter = () => {
        setShowTooltip(true);
    };

    const handleMouseLeave = () => {
        setShowTooltip(false);
    };

    return (
        <div className="layout">
            <div className="icon-container">

                <Header rightComponent={
                    <div style={{ display: 'flex', alignItems: 'center', gap: 7 }}>
                        {/* Video mode temporarily hidden from header */}
                        {false && shouldRenderIconButton && canAccessQnA == 'yes' && (
                            <div>
                                <IconButton className="icon-button" onClick={chatModeHandler}>
                                    <Videocam />
                                </IconButton>
                            </div>
                        )}
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }} key="participation-toggle">
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8, justifyContent: 'center' }}>
                                <Switch
                                    color="primary"
                                    checked={isParticipated === "true"}
                                    onChange={e => {
                                        if (e.target.checked) {
                                            handleParticipationResponse("yes");
                                        } else {
                                            handleParticipationResponse("no");
                                        }
                                    }}
                                    inputProps={{ 'aria-label': 'Participate in Daily Engagement' }}
                                    style={{ width: 40 }}
                                />
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', marginTop: '0px' }}>
                                <span
                                    style={{
                                        fontSize: '0.8rem',
                                        color: '#666',
                                        marginRight: '8px', // Add some space between text and icon
                                    }}
                                >
                                    6 Ques
                                </span>
                                <span
                                    style={{
                                        display: 'inline-block',
                                        width: '16px',
                                        height: '16px',
                                        backgroundColor: '#185b21',
                                        color: '#ffffff',
                                        textAlign: 'center',
                                        lineHeight: '16px',
                                        borderRadius: '50%',
                                        fontSize: '12px', // Smaller font size
                                        cursor: 'pointer',
                                        position: 'relative',
                                    }}
                                    onMouseEnter={handleMouseEnter}
                                    onMouseLeave={handleMouseLeave}
                                >
                                    i
                                    {showTooltip && (
                                        <div
                                            style={{
                                                visibility: 'visible',
                                                backgroundColor: '#333',
                                                color: '#fff',
                                                textAlign: 'center',
                                                borderRadius: '5px',
                                                padding: '5px',
                                                position: 'absolute',
                                                zIndex: 1,
                                                bottom: '-600%',
                                                left: '50%',
                                                transform: 'translateX(-50%)',
                                                width: '150px',
                                                opacity: 1,
                                                transition: 'opacity 0.3s',
                                            }}
                                        >
                                            Participate in Daily 6 question engagement Program to improve yourself.
                                        </div>
                                    )}
                                </span>
                            </div>
                        </div>
                        {/* Language selector */}
                        <IconButton
                            id="language-menu"
                            title="Select your preferred language"
                            aria-label="Menu"
                            onClick={handleLanguageMenuClick}
                        >
                            <TranslateIcon style={{ fontSize: "20px" }} />
                        </IconButton>
                        <Menu
                            anchorEl={languageMenuAnchorEl}
                            keepMounted
                            open={Boolean(languageMenuAnchorEl)}
                            onClose={handleLanguageMenuChange}
                            PaperProps={{
                                style: {
                                    maxHeight: 200,
                                    overflow: "auto",
                                },
                                className: "scrollbar-languages",
                            }}
                        >
                            {[...languages]
                                .sort((a, b) => (a.value === selectedLanguage ? -1 : b.value === selectedLanguage ? 1 : 0))
                                .map((language) => (
                                    <MenuItem
                                        key={language.value}
                                        onClick={() => handleLanguageChange(language.value)}
                                        style={
                                            selectedLanguage === language.value
                                                ? menuItemStyle.selected
                                                : {}
                                        }
                                        onMouseOver={(e) => {
                                            if (selectedLanguage !== language.value) {
                                                e.currentTarget.style.backgroundColor = menuItemStyle.hover.backgroundColor;
                                            }
                                        }}
                                        onMouseOut={(e) => {
                                            if (selectedLanguage !== language.value) {
                                                e.currentTarget.style.backgroundColor = 'inherit';
                                            }
                                        }}
                                    >
                                        <ListItemText className="menu-item-text">{language.label}</ListItemText>
                                    </MenuItem>
                                ))}
                        </Menu>
                        {/* Header right menu (QnA, etc) */}
                        {renderHeaderRightMenu()}
                        {/* Logout/Login button */}
                        {shouldRenderIconButton ? (
                            <>
                                {/* <IconButton onClick={openDialog} title="Logout" aria-label="Logout" className="icon-button">
                                <LogoutIcon />
                            </IconButton> */}
                            </>
                        ) : (
                            <IconButton onClick={handleLogin} title="Login" aria-label="Login" className="icon-button">
                                <LoginIcon />
                                <span className="icon-text">Log In</span>
                            </IconButton>
                        )}
                        <Dialog open={isDialogOpen} onClose={closeDialog}>
                            <div
                                style={{
                                    width: isMobileView ? "295px" : "350px",
                                    borderRadius: "50px"
                                }}
                            >
                                <DialogTitle style={{ fontSize: "20px", padding: "20px", color: "#595959", display: "flex", flexDirection: "column", alignItems: "center" }}>
                                    <Logout style={{ fontSize: "57px" }} />
                                </DialogTitle>
                                <DialogContent style={{ fontSize: "15.5px", padding: "10px", display: "flex", flexDirection: "column", alignItems: "center" }}>
                                    Are you sure you want to log out?
                                </DialogContent>
                                <DialogActions style={{ display: "flex", justifyContent: "center", padding: "25px" }}>
                                    <Button onClick={closeDialog} size="small"
                                        variant="outlined" style={{ color: "black", textTransform: "none", borderColor: "#c2c2c2", paddingLeft: "16px", paddingRight: "16px" }}>
                                        Cancel
                                    </Button>
                                    <Button onClick={confirmLogout} size="small"
                                        variant="contained" style={{ textTransform: "none", backgroundColor: "#236B48", color: "white", paddingLeft: "16px", paddingRight: "16px" }} autoFocus>
                                        Logout
                                    </Button>
                                </DialogActions>
                            </div>
                        </Dialog>
                    </div>
                } />
                <Outlet />
                <Snackbar
                    open={globalAppState.showNotification}
                    autoHideDuration={5000}
                    onClose={handleNotificationClose}
                    anchorOrigin={{ vertical: "top", horizontal: "center" }}
                >
                    <Alert
                        style={{ maxWidth: 480 }}
                        variant="filled"
                        severity={globalAppState.notificationSeverity}
                        onClose={handleNotificationClose}
                    >
                        {globalAppState.notificationMessage}
                    </Alert>
                </Snackbar>
                <Modal open={showRedirectionWarning} className="logout-modal">
                    <Paper className="content">
                        <WarningAmberOutlined className="icon" />
                        <Typography variant="h6" align="center">
                            Your session has expired. Redirecting you to login screen.
                        </Typography>
                    </Paper>
                </Modal>
            </div>
        </div>
    );
};

export default Layout;
